import { z } from 'zod';
const fileKind = z.enum(['sql', 'notebook', 'pipeline', 'other']);
const count = z.number().int().nonnegative();
const evidence = z.object({ recognizer: z.string(), version: z.string(), reason: z.string() });
const sqlEngine = z.object({
    state: z.enum(['hint', 'unknown', 'conflict']),
    id: z.string(),
    label: z.string(),
    evidence: z.array(evidence),
});
const file = z.object({
    id: z.string(),
    path: z.string(),
    kind: fileKind,
    format: z.string(),
    state: z.enum(['recognized', 'unknown', 'conflict']),
    evidence: z.array(evidence),
    sqlEngine: sqlEngine.optional(),
});
export const workloadContentsObservationSchema = z
    .object({
    version: z.literal(1),
    repositoryId: z.string(),
    sourceRevision: z.string(),
    observedAt: z.string(),
    state: z.enum(['ready', 'unavailable']),
    reason: z.string().optional(),
    totalFiles: count,
    files: z.array(file),
    counts: z.object({ sql: count, notebook: count, pipeline: count, other: count }),
    sqlEngines: z.array(z.object({ id: z.string(), label: z.string(), count })),
    notices: z.array(z.string()),
})
    .refine(value => value.state !== 'ready' ||
    (value.files.length === value.totalFiles &&
        Object.values(value.counts).reduce((sum, total) => sum + total, 0) === value.totalFiles), 'A ready contents observation must account for every file.');
//# sourceMappingURL=workloadContents.js.map